module.exports = __webpack_public_path__ + "assets/icon-button-conversation.3b47d9c8.svg";